/* 
-----------------------------------------------------------------------------
| DATE SELECTION
-----------------------------------------------------------------------------
- description: its only purpose is to manage the value of booking.date
  and reset other values or navigate to other route if needed
*/
import { useRef, useState } from "react";

import { parseDate, getMonthDifference } from "../../utils/helpers";
import { Icon } from "./Icon";
import { DateCell } from "./DateCell";
import { Calendar } from "./Calendar";

export const DateSelector = ({
	monthsAvailability,
	onDateSelected,
	onMonthChange,
	displayedMonthsQty,
	from,
	value,
	at,
}) => {
	const [currentMonthOffset, setCurrentMonthOffset] = useState(
		getMonthDifference(from, at)
	);

	const previousButton = useRef(null);
	const nextButton = useRef(null);
	const reference = new Date(from);
	const date = useRef(
		new Date(
			reference.getFullYear(),
			reference.getMonth() + currentMonthOffset,
			currentMonthOffset === 0 ? reference.getDate() : 1
		)
	);

	const goNextMonth = () => {
		if (
			displayedMonthsQty !== undefined &&
			currentMonthOffset === displayedMonthsQty - 1
		)
			return;
		date.current.setDate(1);
		date.current.setMonth(date.current.getMonth() + 1);
		updateCurrentMonthOffset(currentMonthOffset + 1);
		onMonthChange(date.current);
	};

	const goPreviousMonth = () => {
		if (currentMonthOffset === 0) return;
		date.current.setMonth(date.current.getMonth() - 1);
		if (date.current.getMonth() === reference.getMonth())
			date.current.setDate(reference.getDate());
		updateCurrentMonthOffset(currentMonthOffset - 1);
		onMonthChange(date.current);
	};

	const updateCurrentMonthOffset = (newState) => {
		let safeNewState = Math.max(0, newState);
		if (displayedMonthsQty !== undefined)
			safeNewState = Math.min(newState, displayedMonthsQty - 1);
		setCurrentMonthOffset(safeNewState);
	};

	return (
		<div className="date-selector">
			<div className="calendar-container df">
				<Calendar
					id="date-picker"
					date={date.current}
					value={value}
					className="month df fd-c p-1 fs-0"
					role="region"
					CellComponent={({ dateInfo }) => {
						return (
							<DateCell
								dateInfo={dateInfo}
								onDateSelected={onDateSelected}
								availability={
									monthsAvailability.length &&
									!monthsAvailability.includes(
										parseDate(
											"yyyy-mm-dd",
											dateInfo.dateObject
										)
									)
								}
							/>
						);
					}}
					ControlsComponent={() =>
						displayedMonthsQty > 1 ? (
							<div
								className="controls df"
								role="group"
								aria-label={`${parseDate(
									"November",
									date.current
								)}`}
							>
								<button
									ref={previousButton}
									className={`button b-0 px-4 py-2 transparent r2 df jcc aic outline-shadow`}
									onPointerDown={goPreviousMonth}
									disabled={currentMonthOffset === 0}
									aria-disabled={currentMonthOffset === 0}
								>
									<Icon icon="arrow" aria-hidden />
								</button>
								<button
									ref={nextButton}
									className="button b-0 px-4 py-2 transparent r2 df jcc aic outline-shadow"
									onPointerDown={goNextMonth}
									disabled={
										!!(
											displayedMonthsQty &&
											currentMonthOffset ===
												displayedMonthsQty - 1
										)
									}
									aria-disabled={
										!!(
											displayedMonthsQty &&
											currentMonthOffset ===
												displayedMonthsQty - 1
										)
									}
								>
									<Icon
										icon="arrow"
										className="rt-180"
										aria-hidden
									/>
								</button>
							</div>
						) : null
					}
				/>
			</div>
		</div>
	);
};
